import { useEffect, useMemo } from 'react'
import { queueEzCommand } from 'utils/ezoic/queueEzCommand'

type Props = { ids: number[] }

const PLACEHOLDER_PREFIX = 'ezoic-pub-ad-placeholder-'

/**
 * EzoicAd component for displaying Ezoic ads.
 * @param ids - The placement IDs to display.
 */

export const EzoicAd = ({ ids }: Props) => {
  const idsKey = useMemo(() => ids.join(','), [ids])

  useEffect(() => {
    let cancelled = false

    const placementIds = Array.from(new Set(idsKey.split(',').filter(Boolean).map(Number))).filter(Number.isFinite)
    if (placementIds.length === 0) return

    queueEzCommand((ez) => {
      if (cancelled) return

      // Wait for next paint to ensure placeholders are in DOM
      requestAnimationFrame(() => {
        if (cancelled) return
        if (typeof ez.showAds !== 'function') return

        // Verify all placeholders exist right before calling showAds
        const missingIds = placementIds.filter((id) => !document.getElementById(`${PLACEHOLDER_PREFIX}${id}`))
        if (missingIds.length > 0) return

        ez.showAds(...placementIds)
      })
    })

    return () => {
      cancelled = true
    }
  }, [idsKey])

  return null
}
